import { FormError, FormEmptyError } from "./error";
import $ from "jquery";

export class FormValidator {

    /**
     * FormValidator constructor.
     *
     * @param {jQuery|HTMLElement} form
     */
    constructor(form) {
        this.form = form;
    }

    /**
     * Has input empty value
     *
     * @param {jQuery|HTMLElement} input
     *
     * @throws {FormError}
     */
    isEmpty(input) {
        const required = input.attr('required');
        const isRequired = (required || required === '');
        const value = input.val();
        const type = input.attr('type');

        if (isRequired && !value) {
            throw new FormEmptyError(null, input);
        }

        if (type === 'checkbox' && isRequired && !input.prop('checked')) {
            throw new FormEmptyError(null, input);
        }
    }

    /**
     * Input matches pattern
     *
     * @param {jQuery|HTMLElement} input
     *
     * @throws {FormError}
     */
    matchPattern(input) {
        const pattern = input.attr('pattern');
        const value = input.val();

        if (pattern && value && (new RegExp(pattern)).test(value) === false) {
            throw new FormError(null, input);
        }
    }

    /**
     * Validate input
     *
     * @param {jQuery|HTMLElement} input
     *
     * @throws {FormError}
     */
    validate(input) {
        this.isEmpty(input);
        this.matchPattern(input);
    }

    /**
     * Validate the form and show the errors
     *
     * @returns {number}
     *     Returns the errors count or 0 if the form not has errors
     */
    validateAll() {
        const $inputs = this.form.find('input');
        const _this = this;
        let errors = 0;
        // reset error message styles
        $('[data-form-error-message]').attr('style', '');

        $inputs.each(function() {
            const $this = $(this);

            try {
                _this.validate($this);
            } catch (error) {
                if (error instanceof FormError) {
                    error.show();
                }

                errors++;
            }
        });

        return errors;
    }
}